/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import GlobalSettingSidebar from './GlobalSetting';
import LayerListSidebar from './LayerList';
import LayerOptionSidebar from './LayerOption';
import WidgetListSidebar from './WidgetListSidebar';
import OtherListSidebar from './OtherList';
import CloudModule from './CloudModule';
import { ParticleRain, ParticleExplosion } from './ParticleList';
import { format } from "date-fns";
import TimeRange from "react-timeline-range-slider";

class LegendBox extends React.Component{
    constructor(){
        super();
        this.state = {
            startX: 0,
            startY: 0
        }

        this.onMove = this.onMove.bind(this);
        this.onStop = this.onStop.bind(this);
    }
    componentDidMount(){
        let t = this;
        let name = '.drag' + this.props.index;
        let drag = document.querySelector(name);
        drag.addEventListener('mousedown', function (e) {
            e.preventDefault();
            let startX = e.clientX - drag.offsetLeft;
            let startY = e.clientY - drag.offsetTop;
            t.setState({startX, startY});
            window.addEventListener('mousemove', t.onMove, false);
            window.addEventListener('mouseup', t.onStop, false);
        });
    }
    onMove(e){
        let name = '.drag' + this.props.index;
        let drag = document.querySelector(name);
        let x = e.clientX - this.state.startX;
        let y = e.clientY - this.state.startY;
        drag.style.left = x + 'px';
        drag.style.top = y + 'px';
        drag.style.right = "unset";
        drag.style.bottom = "unset";
    }
    onStop(){
        let t = this;
        window.removeEventListener('mousemove', t.onMove, false);
        window.removeEventListener('mouseup', t.onStop, false);
    }
    render(){
        const {TITLE, COLOR, VALUE} = this.props.legendBoxContent;
        const index = this.props.index;
        let legendrag = "legendBox drag" + this.props.index;
        return(
            <div className={legendrag} style={{transform: "translate3d(0, 0, 0)"}}>
                <div className="ts card">
                    <div className="extra content">
                        <h6>{TITLE}</h6>
                        {
                            COLOR.map((val, index) => {
                                return (
                                    <>
                                        <i style={{background: val}} className="legend-color"></i>
                                        {VALUE[index]} {(VALUE[index] === "無資料") ? null : (index == COLOR.length-1) ? ' 以上' : ' - '+VALUE[index + 1]}
                                        <br></br>
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

class StatusBar extends React.Component{
    constructor(){
        super();
        this.state = {
            camera : {
                x:0.00,
                y:0.00,
                z:0.00
            },
            FPSintervalId:{},
            TerrainintervalId:{},
            MouseintervalId:{},
            fps:0.0,
            terrainNod:0.00
        };
        this.cameraPOS = this.cameraPOS.bind(this);
        this.FPS = this.FPS.bind(this);
        this.getTerrainNod = this.getTerrainNod.bind(this);
    }
    componentDidMount(){
        var MouseintervalId = requestAnimationFrame(this.cameraPOS);
        var FPSintervalId = requestAnimationFrame(this.FPS);
        var TerrainintervalId = requestAnimationFrame(this.getTerrainNod);
        this.setState({FPSintervalId: FPSintervalId,TerrainintervalId:TerrainintervalId,MouseintervalId: MouseintervalId});
    }
    componentWillUnmount(){
        cancelAnimationFrame(this.state.MouseintervalId);
        cancelAnimationFrame(this.state.FPSintervalId);
        cancelAnimationFrame(this.state.TerrainintervalId);
    }
    cameraPOS(){
        var camera = window.main.OView.camera.pos;
        if(camera!==null)
            this.setState({camera:camera});
        requestAnimationFrame(this.cameraPOS);
    }
    FPS(){
        if(window.main !== null){
            var fps = (window.main.OView.getFPS()).toFixed(1);
            this.setState({fps:fps});
            requestAnimationFrame(this.FPS);
        }            
    }
    getTerrainNod(){
        if(window.main !== null){
            var terrainNod = (window.main.OView.getTerrainNodeProgress()).toFixed(2);
            this.setState({terrainNod:terrainNod});
            requestAnimationFrame(this.getTerrainNod);
        }
    }
    render(){
        const x = this.state.camera.x;
        const y = this.state.camera.y;
        const z = this.state.camera.z>=1000 ? (this.state.camera.z/1000).toFixed(2) + " 公里" : (this.state.camera.z).toFixed(2)+" 公尺";
        const fps = this.state.fps;
        const terrainNod = this.state.terrainNod * 100;
        return(
            <div id="statusBar">
                <div id="mousePos">
                    PilotGaea_v.13　　
                    {
                        terrainNod === 100 ?
                        <i className="circle thin icon"></i>
                        :
                        <i className="spinner loading icon"></i>
                    }
                    {terrainNod + "%"}　　FPS：{fps}　　相機高度：{z}　　相機經度：{x.toFixed(6)}　　相機緯度：{y.toFixed(6)}
                </div>
            </div>
        );
    }

}


class ToolBar extends React.Component{
    constructor() {
        super();
        this.state = {
            isSideMenu:[{
                globalSetting:false,
                layerList:false,
                layerOption:false,
                WidgetList: false,
                OtherList: false,
                googleSearch:false,
                IoTSensorThings:false                
            }],
            isCard:[{
                surveying:false,
                analysis:false,
                cloudModule:false,
                particleRain:false,
                particleExplosion:false
            }],
            layerList : {
                Layer_2D:[],
                Layer_3D:[],
                Layer_Noise:[]
            },
            deleteList : {},
            LayerLength:0,
            modalIsOpen:false,
            isinfoBoxOpen:false,
            infoBoxAttr:{
                COL:[],
                ATTR:[]
            },
            showLegend: false,
            legendBoxContent:{
                TITLE: "",
                VALUE: [],
                COLOR: []
            },
            legendList: {
                title: [],
                legend: []
            },
            showTimeLine: false,
            TimeLineContent: {
                TIMElINEINTERVAL: [],
                SELECTEDINTERVAL: []
            },
            selectedInterval:[],
            timelineInterval:[],
            error: false,
            isPlay: false
        };
        this.setglobalSettingOpen = this.setglobalSettingOpen.bind(this);
        this.setWidgetListOpen = this.setWidgetListOpen.bind(this);
        this.setOtherListOpen = this.setOtherListOpen.bind(this);
        this.setlayerListOpen = this.setlayerListOpen.bind(this);
        this.setlayerOptionOpen = this.setlayerOptionOpen.bind(this); 
        this.setgoogleSearchOpen = this.setgoogleSearchOpen.bind(this); 
        this.setIoTSensorThingsOpen = this.setIoTSensorThingsOpen.bind(this);
        this.setSurveyingOpen = this.setSurveyingOpen.bind(this); 
        this.setAnalysisOpen = this.setAnalysisOpen.bind(this);      
        this.setCloudModuleOpen = this.setCloudModuleOpen.bind(this);      
        this.setOpenLayer = this.setOpenLayer.bind(this);
        this.deleteLayer = this.deleteLayer.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.setinfoBoxOpen = this.setinfoBoxOpen.bind(this);
        this.setinfoBox = this.setinfoBox.bind(this);
        this.setLegendBoxSwitch = this.setLegendBoxSwitch.bind(this);
        this.setLegendBoxContent = this.setLegendBoxContent.bind(this);
        this.setTimeLineContent = this.setTimeLineContent.bind(this);
    }
    componentDidUpdate(){
        let selectedInterval = this.state.selectedInterval;
        document.querySelectorAll('.react_time_range__handle_wrapper').forEach(function (item, index) {
            item.setAttribute('data-attr', format(selectedInterval[index], 'yyyy-MM-dd HH'));
        });
    }
    setTimeLineInterval(){
        if (this.state.isPlay) {
            clearInterval(this.timerID);
        } else {
            this.timerID = setInterval(
                () => this.tick(),
                1000
            );
        }
        this.setState({isPlay: !this.state.isPlay});
    }
    tick(){
        let next = new Date(this.state.selectedInterval[0]).getTime() + 3600*1000;
        let selectedInterval = [];
        if (next > new Date(this.state.selectedInterval[1]).getTime()) {
            selectedInterval = [
                this.state.timelineInterval[0],
                this.state.selectedInterval[1]
            ];
        } else {
            selectedInterval = [
                new Date(next),
                this.state.selectedInterval[1]
            ];
        }
        this.setState({selectedInterval});
    }
    setTimeLineContent(content){
        if (this.state.showTimeLine == false){
            this.setState({showTimeLine: !this.state.showTimeLine});
        }
        this.setState({selectedInterval: content.SELECTEDINTERVAL, timelineInterval: content.TIMElINEINTERVAL});
    }
    closeTimeline() {
        let layerList = this.state.layerList.Layer_Noise;
        let needTimeLine = false;
        layerList.forEach(function (layer) {
            if (layer.timeLine !== undefined)
                needTimeLine = true;
        });
        if (!needTimeLine && this.state.showTimeLine)
            this.setState({showTimeLine: !this.state.showTimeLine});
    }
    setLegendBoxContent(content){
        if (this.state.showLegend == false){
            this.setLegendBoxSwitch();
        }
        this.setState({legendBoxContent: content});
    }
    setLegendBoxSwitch(){
        this.setState({showLegend: !this.state.showLegend});
    }
    setLegendList(){
        let layerList = this.state.layerList.Layer_Noise;
        let legendList = {
            title: [],
            legend: []
        };
        layerList.forEach(function (layer) {
            if (layer.legend !== undefined) {
                if (!legendList.title.includes(layer.legend.TITLE)) {
                    legendList.title.push(layer.legend.TITLE);
                    legendList.legend.push(layer.legend);
                }
            }
        });
        this.setState({legendList});
    }
    setinfoBox(attr){
        this.setState({infoBoxAttr: attr});
    }
    setinfoBoxOpen(open = true){
        this.setState({isinfoBoxOpen: open});
    }
    closeModal() {
        this.setState({modalIsOpen: false});
    }
    setglobalSettingOpen(){
        const layerListOpen = [{
            globalSetting:!this.state.isSideMenu[0].globalSetting,
            layerList:false,
            layerOption: false,
            WidgetList: false,
            OtherList: false,
            googleSearch:false,
            IoTSensorThings:false  
        }];
        this.setState({isSideMenu:layerListOpen});
    }
    setWidgetListOpen() {
        const layerListOpen = [{
            globalSetting: false,
            layerList: false,
            layerOption: false,
            WidgetList: !this.state.isSideMenu[0].WidgetList,
            OtherList: false,
            googleSearch: false,
            IoTSensorThings: false
        }];
        this.setState({ isSideMenu: layerListOpen });
    }
    setOtherListOpen() {
        const layerListOpen = [{
            globalSetting: false,
            layerList: false,
            layerOption: false,
            WidgetList: false,
            OtherList: !this.state.isSideMenu[0].OtherList,
            googleSearch: false,
            IoTSensorThings: false
        }];
        this.setState({ isSideMenu: layerListOpen });
    }
    setlayerListOpen(){
        const layerListOpen = [{
            globalSetting:false,
            layerList:!this.state.isSideMenu[0].layerList,
            layerOption:false,
            WidgetList: false,
            OtherList: false,
            googleSearch:false,
            IoTSensorThings:false
        }];
        this.setState({isSideMenu:layerListOpen});
    }
    setlayerOptionOpen(){
        const layerListOpen = [{
            globalSetting:false,
            layerList:false,
            layerOption:!this.state.isSideMenu[0].layerOption,
            WidgetList: false,
            OtherList: false,
            googleSearch:false,
            IoTSensorThings:false
        }];
        this.setState({isSideMenu:layerListOpen});
    }
    setgoogleSearchOpen(){
        const layerListOpen = [{
            globalSetting:false,
            layerList:false,
            layerOption: false,
            WidgetList: false,
            OtherList: false,
            googleSearch:!this.state.isSideMenu[0].googleSearch,
            IoTSensorThings:false
        }];
        this.setState({isSideMenu:layerListOpen});
    } 
    setIoTSensorThingsOpen(){
        const layerListOpen = [{
            globalSetting:false,
            layerList:false,
            layerOption: false,
            WidgetList: false,
            OtherList: false,
            googleSearch:false,
            IoTSensorThings:!this.state.isSideMenu[0].IoTSensorThings
        }];
        this.setState({isSideMenu:layerListOpen});
    }   
    setSurveyingOpen(){
        const CardOpen = [{
            surveying:!this.state.isCard[0].surveying,
            analysis:false
        }];
        this.setState({isCard:CardOpen});
    }
    setAnalysisOpen(){
        const CardOpen = [{
            surveying:false,
            analysis:!this.state.isCard[0].analysis
        }];
        this.setState({isCard:CardOpen});
    }
    setCloudModuleOpen(){
        const CardOpen = [{
            surveying:false,
            analysis:false,
            cloudModule:!this.state.isCard[0].cloudModule,
            particleRain:false,
            particleExplosion:false
        }];
        this.setState({isCard:CardOpen});
    }
    setParticleRainOpen(){
        const CardOpen = [{
            surveying:false,
            analysis:false,
            cloudModule:false,
            particleRain:!this.state.isCard[0].particleRain,
            particleExplosion:false
        }];
        this.setState({isCard:CardOpen});
    }
    setParticleExplosionOpen(){
        const CardOpen = [{
            surveying:false,
            analysis:false,
            cloudModule:false,
            particleRain:false,
            particleExplosion:!this.state.isCard[0].particleExplosion
        }];
        this.setState({isCard:CardOpen});
    }
    setOpenLayer(layer,layerHandel){
        let openLayer = this.state.layerList;
        if (layer.TYPE === "ConditionOverlay") {
            let layer2D = openLayer.Layer_2D;
            if (layer2D.length == 0) {
                openLayer.Layer_2D.push({
                    layerName : layer.TITLE,
                    layerType : layer.TYPE
                });
            } else {
                layer2D.forEach(function (l) {
                    if (l.layerType == "ConditionOverlay") {
                        l.layerName = layer.TITLE;
                    }
                });
            }
        } else if (layer.TYPE === "Overlay"){
            openLayer.Layer_2D.push({
                layerName : layer.TITLE,
                layerType : layer.TYPE
            });
        }
        else {
            if (layer.GROUP !== undefined && layer.GROUP == "noise") {
                openLayer.Layer_Noise.push({
                    group : layer.GROUP,
                    layerName : layer.TITLE,
                    id : layer.ID,
                    layerType : layer.TYPE,
                    layerMode : layer.MODE,
                    layerClass : layer.CLASS,
                    layerLocation : layer.LOCATION,
                    layerHandel : layerHandel,
                    isBIMModel : layer.ISBIM,
                    BIMAttrsList : layer.BIMATTRS,
                    VideoPath : layer.VideoPath,
                    VideoPOS : layer.VideoPOS,
                    VideoV : layer.VideoV,
                    VideoUP : layer.VideoUP,
                    HFov : layer.HFov,
                    VFov : layer.VFov,
                    Far : layer.Far,
                    Near : layer.Near,
                    ImgW : layer.ImgW,
                    ImgH : layer.ImgH,
                    URL : layer.URL,
                    timeLine : layer.TIMELINE,
                    legend : layer.LEGEND
                });
            } else {
                openLayer.Layer_3D.push({
                    layerName : layer.TITLE,
                    id : layer.ID,
                    layerType : layer.TYPE,
                    layerMode : layer.MODE,
                    layerClass : layer.CLASS,
                    layerLocation : layer.LOCATION,
                    layerHandel : layerHandel,
                    isBIMModel : layer.ISBIM,
                    BIMAttrsList : layer.BIMATTRS,
                    VideoPath : layer.VideoPath,
                    VideoPOS : layer.VideoPOS,
                    VideoV : layer.VideoV,
                    VideoUP : layer.VideoUP,
                    HFov : layer.HFov,
                    VFov : layer.VFov,
                    Far : layer.Far,
                    Near : layer.Near,
                    ImgW : layer.ImgW,
                    ImgH : layer.ImgH,
                    URL : layer.URL,
                });
            }
        }
        let LayerLength = openLayer.Layer_2D.length+openLayer.Layer_3D.length+openLayer.Layer_Noise.length;
        this.setState({layerList:openLayer,deleteList:{},LayerLength:LayerLength});
        this.setLegendList();
    }
    deleteLayer(layer){
        let deleteLayerList = this.state.layerList;
        let DeleteList = {
            layerName : layer.TITLE,
            layerType : layer.TYPE
        };
        if(layer.TYPE === "Overlay" || layer.TYPE == "ConditionOverlay"){
            for (let i = 0, len = deleteLayerList.Layer_2D.length; i < len; i++){
                if (deleteLayerList.Layer_2D[i].layerName === layer.TITLE){
                    deleteLayerList.Layer_2D.splice(i, 1);
                    let LayerLength = deleteLayerList.Layer_2D.length+deleteLayerList.Layer_3D.length+deleteLayerList.Layer_Noise.length;
                    this.setState({layerList:deleteLayerList,deleteList:DeleteList,LayerLength:LayerLength});
                    return ;
                }
            }
        } else if (layer.GROUP != undefined && layer.GROUP == "noise") {
            for (let i = 0, len = deleteLayerList.Layer_Noise.length; i < len; i++){
                if (deleteLayerList.Layer_Noise[i].layerName === layer.TITLE){
                    deleteLayerList.Layer_Noise.splice(i, 1);
                    let LayerLength = deleteLayerList.Layer_2D.length + deleteLayerList.Layer_3D.length+deleteLayerList.Layer_Noise.length;
                    this.setState({layerList:deleteLayerList,deleteList:DeleteList,LayerLength:LayerLength});
                    this.setLegendList();
                    this.closeTimeline();
                    return ;
                }
            }
        } else {
            for (let i = 0, len = deleteLayerList.Layer_3D.length; i < len; i++){
                if (deleteLayerList.Layer_3D[i].layerName === layer.TITLE){
                    deleteLayerList.Layer_3D.splice(i, 1);
                    let LayerLength = deleteLayerList.Layer_2D.length + deleteLayerList.Layer_3D.length+deleteLayerList.Layer_Noise.length;
                    this.setState({layerList:deleteLayerList,deleteList:DeleteList,LayerLength:LayerLength});
                    return ;
                }
            }
        }
    }
    errorHandler = ({ error }) => this.setState({ error });
    onChangeCallback = (selectedInterval) => this.setState({selectedInterval});
    render(){
        const globalSetting = this.state.isSideMenu[0].globalSetting;
        const layerListOpen = this.state.isSideMenu[0].layerList;
        const layerOptionOpen = this.state.isSideMenu[0].layerOption;
        const WidgetListOpen = this.state.isSideMenu[0].WidgetList;
        const OtherListOpen = this.state.isSideMenu[0].OtherList;
        const LayerLength = this.state.LayerLength;
        const legendList = this.state.legendList;
        const Layer_2D_Length = (this.state.layerList.Layer_2D).length;
        const infoBoxOpen = this.state.isinfoBoxOpen;
        const showTimeLine = this.state.showTimeLine;
        const {error, timelineInterval, selectedInterval} = this.state;

        let active ;
        if(this.state.modalIsOpen)
            active = "ts modals dimmer active";
        else
            active = "ts modals dimmer";
        
        return(
            <div>                
                <div className={active}>
                    <dialog className="ts modal" open>
                        <i className="close icon" onClick={this.closeModal.bind(this)}></i>
                        <div className="header" style={{textAlign:"center"}}>
                            系統設備性能檢測
                        </div>
                        <div className="content" style={{height:"80vh"}}>
                            <iframe src="https://demo-3dgdp.colife.org.tw/PilotGaea/speedtest/" style={{width:"100%",height:"100%"}}></iframe>
                        </div>
                    </dialog>
                </div> 
                <div className="ts labeled icon left fixed inverted vertical menu">
                    <a className="item" onClick={(e)=>this.setglobalSettingOpen()}>
                        <i className="content icon"></i>
                    </a>
                    <a className="item" onClick={(e)=>this.setlayerListOpen()}>
                        <i className="folder outline icon"></i> 圖層集
                    </a>
                    <a className="item" onClick={(e)=>this.setlayerOptionOpen()}>
                        <i className="inverted sliders icon"></i> 圖層設定
                        {
                            LayerLength === 0 ? null:
                            <div id="tag" class="ts floating circular positive label" style={{top: '1px'}}>{LayerLength}</div>
                        }
                        
                    </a>
                    <a className="item" onClick={(e) => this.setWidgetListOpen()}>
                        <i className="block layout inverted icon"></i> Widget
                    </a>
                    <a className="item" onClick={(e) => this.setOtherListOpen()}>
                        <i className="folder inverted icon"></i> 其他應用
                    </a>
                </div>
                <GlobalSettingSidebar 
                    isglobalSettingOpen={globalSetting} 
                    setglobalSettingOpen={this.setglobalSettingOpen.bind(this)}
                />
                <WidgetListSidebar
                    isWidgetListOpen={WidgetListOpen}
                    setWidgetListOpen={this.setWidgetListOpen.bind(this)}
                />
                <OtherListSidebar
                    isOtherListOpen={OtherListOpen}
                    setOtherListOpen={this.setOtherListOpen.bind(this)} 
                />
                <LayerListSidebar 
                    islayerListOpen={layerListOpen} 
                    setlayerListOpen={this.setlayerListOpen.bind(this)} 
                    setOpenLayer = {(layer,layerHandel)=>this.setOpenLayer(layer,layerHandel)}
                    setinfoBox = {(attr)=>this.setinfoBox(attr)}
                    setinfoBoxOpen = {this.setinfoBoxOpen}
                    setLegendBoxSwitch = {this.setLegendBoxSwitch}
                    setLegendBoxContent = {this.setLegendBoxContent}
                    setTimeLineContent = {this.setTimeLineContent}
                    deleteLayer = {(layer)=>this.deleteLayer(layer)}
                    deleteList = {this.state.deleteList}
                    LayerLength = {Layer_2D_Length}
                    currentTime={selectedInterval}
                    setCloudModuleOpen={this.setCloudModuleOpen}
                    setParticleRainOpen={this.setParticleRainOpen.bind(this)}
                    setParticleExplosionOpen={this.setParticleExplosionOpen.bind(this)}
                />
                <LayerOptionSidebar 
                    islayerOptionOpen={layerOptionOpen} 
                    setlayerOptionOpen={this.setlayerOptionOpen.bind(this)}
                    infoBoxAttr={this.state.infoBoxAttr}
                    setinfoBox={this.setinfoBox}
                    setLegendBoxSwitch={this.setLegendBoxSwitch}
                    deleteLayerList={(layer)=>this.deleteLayer(layer)}
                    LayerList = {this.state.layerList}
                    currentTime={selectedInterval}
                />
                <CloudModule isOpen={this.state.isCard[0].cloudModule} setCloudModuleOpen={this.setCloudModuleOpen} />
                <ParticleRain isOpen={this.state.isCard[0].particleRain} setParticleRainOpen={this.setParticleRainOpen.bind(this)} />
                <ParticleExplosion isOpen={this.state.isCard[0].particleExplosion} setParticleExplosionOpen={this.setParticleExplosionOpen.bind(this)} />
                <InfoBox 
                    isinfoBoxOpen={infoBoxOpen} 
                    setinfoBoxOpen={this.setinfoBoxOpen.bind(this)} 
                    infoBoxAttr={this.state.infoBoxAttr} />
                {
                    legendList.legend.map((legend, index) => {
                        return <LegendBox 
                            legendBoxContent={legend}
                            index={index}
                        />
                    })
                }
                <div className="timeline" style={{display: showTimeLine?'block':'none'}}>
                    <i className={this.state.isPlay ? "circular large pause icon" : "circular large play icon"} onClick={(e)=>this.setTimeLineInterval()}></i>
                    <TimeRange
                        error={error}
                        step={3600000}
                        ticksNumber={9}
                        selectedInterval={selectedInterval}
                        timelineInterval={timelineInterval}
                        onUpdateCallback={this.errorHandler}
                        onChangeCallback={this.onChangeCallback}
                        formatTick={(ms) => format(new Date(ms), 'yyyy-MM-dd HH')}
                    />
                </div>
                <StatusBar />

            </div>            
        );
    }
}

class InfoBox extends React.Component{
    constructor() {
        super();
        this.infoBoxSwitch = this.infoBoxSwitch.bind(this);
    }
    infoBoxSwitch(open){
        this.props.setinfoBoxOpen(open);
    }
    render(){
        const isinfoBoxOpen = this.props.isinfoBoxOpen;
        const infoBoxStyle = {
            transform: isinfoBoxOpen?'translate3d(0, 0, 0)':'translate3d(120%, 0, 0)',
            transition: "0.2s",
            position: "fixed",
            top: "5px",
            right: "5px",
            width: "20vw",
            maxWidth: "400px"
        };
        const {COL, ATTR} = this.props.infoBoxAttr;
        const en_zh = {
            NO: "建物編號",
            roofElevat: "頂樓高度(公尺)",
            floors: "樓層數",
            noice: "每小時均能音量(dBA)"
        }
        return(
            <div id="infoBox" style={infoBoxStyle}>
                <div className="ts dismissable message">
                    <i className="ts close button" onClick={(e)=>this.infoBoxSwitch(false)}></i>
                    <table className="ts celled striped table">
                        <thead>
                            <tr>
                                <th colspan="3">屬性資料</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            COL.map((col, index) => {
                                if (index > 0) {
                                    return (
                                        <tr>
                                            <td>{en_zh[col]}</td>
                                            <td className="right aligned collapsing">{ATTR[index]}</td>
                                        </tr>
                                    )
                                }
                            })
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default ToolBar;
